import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export interface PuedeDesactivar {
  permitirSalidaDeRuta: () => Observable<boolean> | Promise<boolean> | boolean
}

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<PuedeDesactivar> {

  /**
   * Permite la salida de un determinado formulario
   */
  canDeactivate(component: PuedeDesactivar) {
    return component.permitirSalidaDeRuta ? component.permitirSalidaDeRuta() : true;
  }

}
